import { ApiEpAcademy } from "@smp/api";
import { Await } from "@smp/utils";
import { useQuery, UseQueryOptions } from "react-query";

const KEY = "ep.academy.progress";

export const useSmpAcademyProgressRetrieve = (options?: {
  useQueryOptions?: Omit<
    UseQueryOptions<Await<ReturnType<typeof ApiEpAcademy.Progress.retrieve>>>,
    "queryKey" | "queryFn"
  >;
}) => {
  const {
    data: academyProgress,
    isLoading: isProgressLoading,
    error: academProgressError,
  } = useQuery(
    [KEY],
    () => ApiEpAcademy.Progress.retrieve(),
    options?.useQueryOptions,
  );

  return {
    academProgressError,
    academyProgress,
    isProgressLoading,
  };
};

useSmpAcademyProgressRetrieve.KEY = KEY;
